var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('label',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('label',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.subtitle)+" متكامل")])])}
var staticRenderFns = []

export { render, staticRenderFns }